import { PureComponent } from 'react';
import PropTypes from 'prop-types';

const didCustomerLogIn = (prevCustomerNum, newCustomerNum) =>
  (prevCustomerNum === null && newCustomerNum !== null);

export default class AfterLoginFreshener extends PureComponent {
  static propTypes = {
    customerNum: PropTypes.string, // eslint-disable-line react/no-unused-prop-types
    isFetchingUserData: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
    refreshPage: PropTypes.func.isRequired,
  };

  componentDidUpdate(prevProps) {
    if (this.shouldRefreshPage(prevProps, this.props)) {
      this.props.refreshPage();
    }
  }

  shouldRefreshPage(prevProps, nextProps) {
    if (didCustomerLogIn(prevProps.customerNum, nextProps.customerNum)) {
      if (nextProps.isFetchingUserData) {
        this.isPageRefreshPending = true;
        return false;
      } else {
        return true;
      }
    }
    if (this.isPageRefreshPending && !nextProps.isFetchingUserData) {
      this.isPageRefreshPending = false;
      return true;
    }
    return false;
  }

  render = () => null;
}
